"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var mobileRouter = {
  path: '/javaMobile',
  component: _layout.default,
  redirect: '/javaMobile/index',
  name: 'Mobile',
  alwaysShow: true,
  meta: {
    title: '移动端',
    icon: 'clipboard'
  },
  children: [{
    path: 'orderCancellation',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/mobile/orderCancellation/index.vue'));
      });
    },
    name: 'OrderCancellation',
    meta: {
      title: '订单核销',
      icon: ''
    }
  }, {
    path: 'orderStatistics',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/mobile/orderStatistics/index.vue'));
      });
    },
    name: 'OrderStatistics',
    meta: {
      title: '订单统计'
    }
  }, {
    path: 'orderList/:types?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/mobile/orderStatistics/orderList.vue'));
      });
    },
    name: 'OrderList',
    meta: {
      title: '订单列表'
    }
  }, {
    path: 'orderDelivery/:oid/:id?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/mobile/orderStatistics/orderDelivery.vue'));
      });
    },
    name: 'OrderDelivery',
    meta: {
      title: '订单发货'
    }
  }, {
    path: 'orderDetail/:id?/:goname?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/mobile/orderStatistics/orderDetail.vue'));
      });
    },
    name: 'OrderDetail',
    meta: {
      title: '订单详情'
    }
  }, {
    path: 'orderStatisticsDetail/:type/:time?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/mobile/orderStatistics/Statistics.vue'));
      });
    },
    name: 'OrderStatisticsDetail',
    meta: {
      title: '订单数据统计'
    }
  }]
};
var _default = exports.default = mobileRouter;